import React from 'react';
import SubscriptionPlans from '../../../../shared/SubscriptionCheckout/SubscriptionPlans/SubscriptionPlans';
import useGetAgentCheckoutLinks from '../../../../Hooks/Agent/Getters/useGetAgentCheckoutLinks/useGetAgentCheckoutLinks';
import useGetAgentSubscription from '../../../../Hooks/Agent/Getters/useGetAgentSubscription/useGetAgentSubscription';
import useSettings from '../../../../Hooks/Shared/useSettings/useSettings';
import tiers from './subscriptionTiersData';

/** @returns {JSX.Element} */
export default function Checkout() {
	const checkoutLinks = useGetAgentCheckoutLinks();
	const subscriptionData = useGetAgentSubscription();
	const settings = useSettings();
	const hasGroupSubscription =
		subscriptionData.data?.subscriptionLevels?.includes('group') ?? false;
	const highestGroupTier = hasGroupSubscription
		? Math.max(
				0,
				...Object.values(
					settings?.userTiers?.agent_group_tiers ?? {}
				).map((tier) => tier ?? 0)
		  )
		: 0;

	return (
		<section className="pt-6">
			<SubscriptionPlans
				checkoutRole="agent"
				groupTierFloor={
					highestGroupTier > 0 ? highestGroupTier : undefined
				}
				isGettingData={checkoutLinks.isGettingData}
				paymentLinks={checkoutLinks.data}
				subscription={subscriptionData.data}
				tiers={tiers}
			/>
		</section>
	);
}
